// extracted by mini-css-extract-plugin
export var actions = "_1g-0";
export var actionsContainer = "_1g-7";
export var border = "_1g-1";
export var childFullHeight = "_1g-e";
export var collapse = "_1g-2";
export var content = "_1g-9";
export var contentChild = "_1g-d";
export var fullscreen = "_1g-b";
export var hasLeftRadius = "_1g-j";
export var headerContainer = "_1g-3";
export var headerRow = "_1g-5";
export var hidePadding = "_1g-a";
export var navCollapsedGap = "_1g-k";
export var noScrollX = "_1g-l";
export var noScrollY = "_1g-m";
export var noTopPadding = "_1g-h";
export var optOutTopPadding = "_1g-c";
export var pageMain = "_1g-i";
export var pageOuter = "_1g-f";
export var pagePadding = "_1g-8";
export var profile = "_1g-n";
export var profileContainer = "_1g-o";
export var profileImage = "_1g-p";
export var profileMain = "_1g-q";
export var profileSubtitle = "_1g-s";
export var profileTitle = "_1g-r";
export var showLeftPadding = "_1g-g";
export var tabsPortalSlot = "_1g-6";
export var tabsWrapper = "_1g-4";
export var title = "_1g-t";